module.exports = __webpack_public_path__ + "media/images/footer_forum-90be852d65b7bb2993e5cb80c4a0f621.png";